import {
  login,
  logout,
  getInfo,
  loginChild
} from '@/api/user' // eslint-disable-line
import {
  getToken,
  setToken,
  removeToken,
  userName,
  userRole,
  location,
  locationCode,
  usermassage
} from '@/utils/auth'
import router, {
  resetRouter,
  asyncRoutes
} from '@/router'
import {
  filterAsyncRoutes
} from '@/store/modules/permission'
import {
  Message
} from 'element-ui'
// import { Base64 } from 'js-base64'
const base64 = require('js-base64').Base64
// const _this = this

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: userRole(),
  routerlist: [],
  location: location(), // 用于判断省市县的具体地址
  userName: userName(),
  usermassage: usermassage(),
  locationCode: locationCode() // 三级联动
}

const mutations = {

  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, {
    roles,
    location,
    locationCode,
    usermassage
  }) => {
    state.roles = roles || '角色'
    state.location = location || ['北京 ']
    state.locationCode = locationCode || ['11']
    state.usermassage = usermassage
  },
  ROUTERCHANGE(state, value) {
    state.routerlist = value
  },
  USER_NAME(state, userName) {
    state.userName = userName
  }

}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    const {
      username,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password
      }).then(response => {
        if (response.code === 501) {
          return Message.error(response.message)
        }
        if (response.code === 500) {
          return Message.error(response.message)
        }
        if (response.code === 407) {
          return Message.error(response.message)
        }
        if (response.code === 406) {
          return Message.error(response.message + '请联系管理员!')
        }
        if (response.code === 200) {
          const token = JSON.parse(base64.decode(response.data.split('.')[1]))
          const rolesa = token.userRole
          const userName = token.userName

          const {
            data
          } = response
          commit('SET_TOKEN', data)
          setToken(data)

console.log(token ,'token ======================================')
          commit('SET_ROLES', {
            roles: token.userRole,
            location: token.location,
            locationCode: token.locationCode,
            usermassage: token
          })
          commit('USER_NAME', userName)
          // Message({
          //   message: '登录成功' + rolesa,
          //   type: 'success'
          // })
        }

        resolve()
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  loginChild({
    commit
  }, userInfo) {
    const {
      username,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      loginChild({
        username: username.trim(),
        password: password
      }).then(response => {
        if (response.code === 501) {
          return Message.error(response.message)
        }
        if (response.code === 500) {
          return Message.error(response.message)
        }
        if (response.code === 407) {
          return Message.error(response.message)
        }
        if (response.code === 406) {
          return Message.error(response.message + '请联系管理员!')
        }
        if (response.code === 200) {
          const token = JSON.parse(base64.decode(response.data.split('.')[1]))
          const rolesa = token.userRole
          const userName = token.userName
          const {
            data
          } = response
          commit('SET_TOKEN', data)
          setToken(data)

          commit('SET_ROLES', {
            roles: token.userRole,
            location: token.location,
            locationCode: token.locationCode,
            usermassage: token
          })
          commit('USER_NAME', userName)
          // Message({
          //   message: '登录成功' + rolesa,
          //   type: 'success'
          // })
        }

        resolve()
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const token = JSON.parse(base64.decode(state.token.split('.')[1]))
        const rolesa = [token.userRole]
        // commit('SET_ROLES', rolesa)
        commit('SET_ROLES', {
          role: token.userRole,
          location: token.location,
          locationCode: token.locationCode
        })

        const accessRoutes = filterAsyncRoutes(asyncRoutes, rolesa)
        commit('ROUTERCHANGE', router)
        router.options.routes.push(accessRoutes)
        resolve(rolesa)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      // commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      dispatch('permission/resetRoutes', null, {
        root: true
      })

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      // dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({
    commit,
    dispatch
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      // commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      dispatch('permission/resetRoutes', null, {
        root: true
      })
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({
    commit,
    dispatch
  }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    // const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    // const accessRoutes = await dispatch('permission/generateRoutes')
    // dynamically add accessible routes
    router.addRoutes(accessRoutes) // eslint-disable-line

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
